import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

const TONI = ['success', 'warning', 'info', 'neutral'];

const useStyles = makeStyles((theme) => ({
  pillola: {
    ...theme.typography.caption,
    display: 'inline-block',
    padding: theme.spacing(0.25, 1.25),
    borderRadius: theme.shape.pillRadius,
    border: '1px solid',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    cursor: 'default',
  },
  ...Object.fromEntries(
    TONI.map((tono) => [
      tono,
      {
        backgroundColor: theme.palette.statusBadge[tono].bg,
        borderColor: theme.palette.statusBadge[tono].border,
        color: theme.palette.statusBadge[tono].text,
      },
    ]),
  ),
}));

const Pillola = React.forwardRef(({ tono, children, ...altre }, ref) => {
  const classes = useStyles();
  return (
    <span
      ref={ref}
      {...altre}
      className={`${classes.pillola} ${classes[tono]}`}
    >
      {children}
    </span>
  );
});

Pillola.displayName = 'Pillola';

Pillola.propTypes = {
  tono: PropTypes.oneOf(TONI).isRequired,
  children: PropTypes.node.isRequired,
};

export default Pillola;
